import { useState, useEffect, useRef } from "react";
import Config from "../../../../Config";
import InputText from "../../../../helpers/InputText";
import AppContext from "../../../../AppContext";
import InputPagger from "../../../../helpers/InputPagger";
import InputLegend from "../../../../helpers/InputLegend";
import SortBy from "../../../../helpers/SortBy";
import MenuTable from "../../../../helpers/MenuTable";

import Csv from "../../../../exporter/Csv";
import Print from "../../../../exporter/Print";
import HtmlToPDF from "../../../../exporter/HtmlToPDF";
import Xlsx from "../../../../exporter/Xlsx";
import SslForm from "./SslForm";



function Ssl(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filterParam, setFilterParam] = useState({

        domena:  props.mainView.readFilter('domena',''),

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);


    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0);

    const [view, setView] = useState ( "list");

    const [legend, setLegend] = useState([
        {
            cls:'color_deleted2',
            title: 'certyfikat wygasł',
        },
    ]);



        const valChangeListener = (filedName, val, correct, msg) => {

            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 500;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null);
                    } , defTimeOut );
            }

            props.mainView.writeFilter(filedName, val);
        }


        const goNextNew = () => {
            setTab(null);
        }

        const filterClear = () => {

            props.mainView.writeFilter('domena', '');

            setFilterParam({

                domena: '',

                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 50,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {
            setTab(null)
        }



        const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
        }

        const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
        }




    const getTab = () => {

        props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_tools,ssl', {
            method: 'POST',
            body: JSON.stringify(filterParam),
            headers: {
                'Content-Type': 'application/json',
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {

                props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);
                    }else
                    {
                        setTab(res.result);
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );
                    }
         } )
         .catch(err => {
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   props.mainView.hideProgress();
         });


         return false;
    }



    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');
            setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = ( ) => {
        setView({...view, ["v"]:"list", ["id"]:-1 });
    }


   const onSuccess = ( ) => {
        setView({...view, ["v"]:"list", ["id"]:-1 });
        getTab();
    }


    const download = (id) => {

        props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_tools,ssl_download', {
            method: 'POST',
            body: JSON.stringify({ id: id }),
            headers: {
                'Content-Type': 'application/json',
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {

                props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);
                    }else
                    {
                        var anchor = document.createElement('a');
                        anchor.href = "data:application/zip;base64," + res.result;
                        anchor.download = res.nazwa;
                        document.body.appendChild(anchor);
                        anchor.click();
                        document.body.removeChild(anchor);
                    }
         } )
         .catch(err => {
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   props.mainView.hideProgress();
         });
    }



   const keyListener = (e) => {
                       var code = e.keyCode ? e.keyCode : e.which;

                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )
                        {
                                e.target.blur();
                                filterClear();
                        }else
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )
                        {
                                filterClear();
                        }else
                        if( e.target.nodeName.toLowerCase() == "body" && code === 37 && filterParam.page > 1)  //left
                        {
                                setFilterParam( {...filterParam,   ['page']: filterParam.page-1  } );
                                setTab(null);
                        }else
                        if(e.target.nodeName.toLowerCase() == "body" && code === 39 && filterParam.page < filterParam.pages)  //right
                        {
                                setFilterParam( {...filterParam,   ['page']: filterParam.page+1  } );
                                setTab(null);
                        }else
                        if (e.target.nodeName.toLowerCase() == "body" && code === 107) { //add +
                            setView({...view, ["v"]:"new", ["id"]:"-1" });
                        }else
                        {
                            props.keyListener(e);
                        }
   }



   useEffect( ()=>{

            if(Config.env == "dev") console.log("Ssl.js, listener on");
            window.onkeydown = keyListener;

            return () => {
                 if(Config.env == "dev") console.log("Ssl.js, listener off");
                 window.onkeydown = props.keyListener;
            };

    } );



    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 });
        setTab(null);
    }



    if(tab == null)
    {
        setTab([]);
        getTab();
        return <div>
            ...
        </div>
    }


    if(view.v == "new")
    {
        return <SslForm  userData={props.userData} mainView={props.mainView} onBack={onBack}   keyListener={keyListener}   onSuccess={onSuccess} />
    }


    document.title = "Certyfikaty SSL";


    var sortList = [
        {column: "created_at", name: "Data utworzenia"  },
        {column: "domena", name: "Domena"  },
    ]


    var titleRaport = "Certyfikaty SSL";

    var now = new Date();

    const rowClass = (row, ix) => {
            var rowStyle = " row ";
            if(ix % 2 == 0 )rowStyle = " row2 ";
            if(row.niewazny_po && new Date(row.niewazny_po) < now) rowStyle = " color_deleted2 ";
            return rowStyle;
    }


    return  <div className="view_content">


                <h3 className="dash_header">Certyfikaty SSL</h3>


               <div className="table_filter">

                        <div className="filter_controll">
                                <label>Domena: </label>
                                <InputText   userData={props.userData} value={filterParam.domena}   valChange={valChangeListener} goNext={goNextNew} name="domena" placeholder={"Domena: "} className="w300"  />
                        </div>

                        <div className="filter_btn">
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść [esc]</span>
                        </div>
               </div>




                <div className="table_widget">
                              <div className="btn" onClick={changeView} v="new" id="-1"  > wygeneruj certyfikat [+]</div>

                              &nbsp;&nbsp;

                              <InputPagger filter={filterParam}  onChange={onChangePagger}  />

                              <InputLegend items={legend} />


                              &nbsp; &nbsp;
                                    <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={titleRaport} />
                                    <Csv tabRef={tab2Ref}  title={titleRaport} />
                                    <Xlsx tabRef={tab2Ref}  title={titleRaport} />
                                    <Print tabRef={tab2Ref}   title={titleRaport} />


                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />
                </div>


               <div className="bg_center">


                        <div ref={tabRef} className="gohide">
                                    <h3>{titleRaport}</h3>

                            <table className="table"  ref={tab2Ref} >

                                     <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                <td>Domena</td>
                                                <td>Wersja</td>
                                                <td>Data wygenerowania</td>
                                                <td className="td_right">Ważny do</td>
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            return <tr className={rowClass(row, ix)} key={ix}>
                                                                <td>{ix+1}</td>
                                                                <td>{row.domena}</td>
                                                                <td className="gocenter">{row.wersja}</td>
                                                                <td className="gocenter">{row.data_wygenerowania}</td>
                                                                <td className="gocenter">{row.niewazny_po}</td>
                                                            </tr>

                                                    } )
                                                }

                                        </tbody>

                                </table>
                        </div>


                        <table className="table"  >

                                     <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                <td>Domena</td>
                                                <td>Wersja</td>
                                                <td>Data wygenerowania</td>
                                                <td className="td_right">Ważny do</td>
                                                <td className="td_option"></td>
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            return <tr className={rowClass(row, ix)} key={ix}>
                                                                <td>{ix+1}</td>
                                                                <td>{row.domena}</td>
                                                                <td className="gocenter">{row.wersja}</td>
                                                                <td className="gocenter">{row.data_wygenerowania}</td>
                                                                <td className="gocenter">{row.niewazny_po}</td>
                                                                <MenuTable>
                                                                    <ul>
                                                                        <li onClick={ ()=>{download(row.id)} }>Pobierz ZIP</li>
                                                                    </ul>
                                                                </MenuTable>
                                                            </tr>

                                                    } )
                                                }

                                        </tbody>

                                </table>

               </div>

    </div>
}


export default Ssl;
